import React, { useRef, useState } from "react";
import { TextPromptProposalChips } from "@/components/flow/build/Steps/Prompt/SidebarContent/Annotate/TextPromptProposalChips";
import Button from "@scripts/react/components/Button";
import { PromptingTipsCard } from "@/components/tutorial/PromptingTipsCard";

interface NoResultsEmptyStateProps {
    labelName: string;
}

export const NoResultsEmptyState: React.FC<NoResultsEmptyStateProps> = ({ labelName }) => {
    const [isTipsModalOpen, setIsTipsModalOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    return (
        <div className="flex flex-col gap-2 border-t border-gray-300 px-4 pt-4">
            <p className="text-xs font-normal text-tertiary">
                No objects found. Delete or try another word:{" "}
            </p>
            {/* Hide the "Try these:" header from TextPromptProposalChips using CSS */}
            <div className="[&>div>div:first-child]:hidden">
                <TextPromptProposalChips
                    isDisabled={false}
                    showPoweredBy={false}
                    sourceLabel={labelName}
                />
            </div>
            <div className="flex w-full pt-1">
                {/* @ts-expect-error - Button component type issue */}
                <Button
                    forwardedRef={buttonRef}
                    className="w-full !bg-gray-100"
                    type="ghost"
                    size="xsmall"
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        setIsTipsModalOpen((prev) => !prev);
                    }}
                >
                    <i className="far fa-info-circle" />
                    Prompting tips
                </Button>
            </div>
            <PromptingTipsCard
                isOpen={isTipsModalOpen}
                onClose={() => setIsTipsModalOpen(false)}
                anchorElement={buttonRef.current}
            />
        </div>
    );
};
